export default __webpack_public_path__ + "static/media/vector.320aa0c8.svg";